import {Component, OnInit} from '@angular/core';
import {environment} from '@env/environment';
import {WindowRefService, SiteInfosService} from '@app/core';
import {MatDialog} from '@angular/material';
import {LangComponent} from '../header/modals/lang/lang.component'
import {CurrencyComponent} from '../header/modals/currency/currency.component'

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
    version = environment.version;
    isOpen: boolean = false;
    noFacilities : boolean;
    noLandMarks : boolean;
    navItems = [];
    langs: Array<{}> = [];
    currency: Array<{}> = [];

    constructor(private winRef: WindowRefService, private siteInfosService: SiteInfosService, public dialog: MatDialog) {
        this.langs = this.siteInfosService.getlistLangs();
        this.currency = this.siteInfosService.getlistCurrency();
    }

    ngOnInit() {
        this.noLandMarks = this.siteInfosService.getLandMarks() && this.siteInfosService.getLandMarks().length == 0;
        this.noFacilities = this.siteInfosService.getlistFacilities().length == 0;
        this.navItems = this._navItems();
    }
    
    /**
     * get logo etablissement
     * @returns string
     */
    get logo():string {
        if(this.siteInfosService.getEtabData()['LogoCPUri'])
            return this.winRef.appConfigSite.hosteimageimg + 'images/' + this.winRef.appConfigSite.idEtab + '/upload/' +this.siteInfosService.getEtabData()['LogoCPUri'];
        else 
            return null
    }
    
    private _navItems() : Array<any> {
        if (this.winRef.appConfigSite.oldVersion) {
            let result = [],
                list = [
                    {linkPC: '/', linkMobile: '/', title: 'static.accueil', enabledPC: true},
                    {linkPC: '/#nos_suites', linkMobile: '/rooms.php', title: 'static.chambresetsuites', enabledPC: true},
                    {linkPC: '/#services', linkMobile: '/services.php', title: 'static.nosservices', enabledPC: true},
                    {linkPC: '/#map', linkMobile: '/contact.php', title: 'static.contact', enabledPC: true},
                    {linkPC: '/', linkMobile: '/galeries.php', title: 'static.galerie', enabledPC: false},
                ];
            // let mob = this.winRef.appConfigSite.isMobile ? 'mobile/' : '/';
            let mob = this.winRef.appConfigSite.isMobile ? 'mobile/' : '';
            for (let item of list) {
                result.push({
                    link: ''.concat(this.winRef.appConfigSite.host, mob, this.winRef.appConfigSite.defaultlangue, this.winRef.appConfigSite.isMobile ? item.linkMobile : item.linkPC),
                    title: item.title,
                });
            }
            return result;
        } else {
            let result = [],
            list = [
                {linkPC: '/', linkMobile: '/', title: 'static.accueil', enabledPC: true},
                {linkPC: '/#rooms', linkMobile: '/#rooms', title: 'static.chambresetsuites', enabledPC: true},
                {linkPC: '/#equipments', linkMobile: '/#equipments', title: 'static.facilities', enabledPC: this.siteInfosService.getLandMarks() && this.siteInfosService.getLandMarks().length != 0},
                {linkPC: '/#comments', linkMobile: '/#comments', title: 'static.commentaires', enabledPC: this.siteInfosService.getCommentByLang(this.winRef.appConfigSite.defaultlangue).length != 0},
                {linkPC: '/#facilities', linkMobile: '/#facilities', title: 'static.propertysurroundings', enabledPC: this.siteInfosService.getlistFacilities().length != 0},
                {linkPC: '/#services', linkMobile: '/#services', title: 'static.nosservices', enabledPC: this.siteInfosService.getService().length != 0},
                {linkPC: '/#galerie', linkMobile: '/#galerie', title: 'static.galerie', enabledPC: true},
                {linkPC: '/#contact', linkMobile: '/#contact', title: 'static.contact', enabledPC: true},
            ];
            let mob = /*this.winRef.appConfigSite.isMobile ? 'mobile/' : */'';
            for (let item of list) {
                if((item.title == "static.facilities" && this.noFacilities) || (item.title == "static.propertysurroundings" && this.noLandMarks)){
                    continue;
                }
                result.push({
                    link: ''.concat(this.winRef.appConfigSite.host, mob, this.winRef.appConfigSite.defaultlangue, this.winRef.appConfigSite.isMobile ? item.linkMobile : item.linkPC),
                    title: item.title,
                    enabledPC: item.enabledPC,
                });
            }
            return result;
        }
    }

    openDialogLang() {
        const dialogRef = this.dialog.open(LangComponent, {
            data: {lang: this.langs}
        });
    }
    openDialogCuurency() {
        const dialogRef = this.dialog.open(CurrencyComponent, {
            data: {currency: this.currency}
        });
    }

}
